import { createFileRoute } from '@tanstack/react-router';

import { SpecificationsPage } from '@/features/design/specifications-page';

export const Route = createFileRoute('/_app/projects/$projectId/design/specifications')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <SpecificationsPage projectId={projectId} />;
}
